import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
export function About() {
  const {
    t
  } = useLanguage();
  const fireImages = ['https://cdn.magicpatterns.com/uploads/c1ZmDU3C6WskkR3WmAw9Qf/WhatsApp_Image_2026-05-03_at_13.06.12_(1).jpg', 'https://cdn.magicpatterns.com/uploads/nTNcXfjJQuNq5SAYPCgn8b/WhatsApp_Image_2026-05-03_at_13.06.12_(2).jpg', 'https://cdn.magicpatterns.com/uploads/1bY68EVbHXo2mFDtuYJJks/WhatsApp_Image_2026-05-03_at_13.06.12_(3).jpg'];
  return <section id="about" className="py-32 lg:py-44 overflow-hidden relative" data-id="element-23">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full z-0" data-id="element-24">
        <video autoPlay loop muted playsInline className="object-cover w-full h-full opacity-30 scale-105" data-id="element-25">
          <source src="https://videos.pexels.com/video-files/2169880/2169880-uhd_2560_1440_24fps.mp4" type="video/mp4" data-id="element-26" />
        </video>
        <div className="absolute inset-0 bg-warmWhite/90 backdrop-blur-[2px]" data-id="element-27" />
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 relative z-10" data-id="element-28">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-28" data-id="element-29">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1.2,
          ease: [0.4, 0, 0.2, 1]
        }} className="w-full lg:w-5/12 relative" data-id="element-30">
            <div className="relative aspect-[3/4] w-full rounded-xs overflow-hidden shadow-elegant" data-id="element-31">
              <img src="https://cdn.magicpatterns.com/uploads/x52NZ2JfPmpgvAphx1RRRa/Captura_de_pantalla_2026-04-17_a_las_14.51.27.png" alt="Nuestro Chef" className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-32" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/15 to-transparent" data-id="element-33" />
            </div>
            {/* Decorative accent frame */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border border-sand/15 rounded-xs -z-10" data-id="element-34"></div>
            {/* Warm glow */}
            <div className="absolute -top-10 -left-10 w-48 h-48 bg-sunset-gold/10 rounded-full blur-3xl -z-10" data-id="element-35"></div>
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1.2,
          delay: 0.2,
          ease: [0.4, 0, 0.2, 1]
        }} className="w-full lg:w-7/12 flex flex-col justify-center" data-id="element-36">
            <div className="flex items-center gap-5 mb-8" data-id="element-37">
              <div className="h-px w-16 bg-gradient-to-r from-sand to-sand/30" data-id="element-38"></div>
              <span className="text-sand text-[11px] font-medium tracking-[0.35em] uppercase" data-id="element-39">
                {t.about.subtitle}
              </span>
            </div>

            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-navy mb-12 leading-[1.1]" data-id="element-40">
              {t.about.title}
            </h2>

            <div className="space-y-8 text-dark/55 font-light leading-[2] text-[15px]" data-id="element-41">
              <p data-id="element-42">{t.about.description1}</p>
              <p data-id="element-43">{t.about.description2}</p>
            </div>

            <div className="mt-16 flex items-center gap-6" data-id="element-44">
              <div className="h-px w-24 bg-gradient-to-r from-sand/40 to-transparent" data-id="element-45"></div>
              <div className="w-1.5 h-1.5 rounded-full bg-sand/40" data-id="element-46"></div>
            </div>
          </motion.div>
        </div>

        {/* Timeline Section */}
        <div className="mt-32 lg:mt-44 max-w-4xl mx-auto" data-id="element-47">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.4, 0, 0.2, 1]
        }} className="text-center mb-20" data-id="element-48">
            <h3 className="font-serif text-3xl md:text-4xl text-navy mb-6" data-id="element-49">
              {t.about.timelineTitle}
            </h3>
            <div className="flex justify-center items-center gap-4" data-id="element-50">
              <div className="h-px w-12 bg-sand/40" data-id="element-51"></div>
              <div className="w-1.5 h-1.5 rounded-full bg-sand" data-id="element-52"></div>
              <div className="h-px w-12 bg-sand/40" data-id="element-53"></div>
            </div>
          </motion.div>

          <div className="space-y-24 relative" data-id="element-54">
            {/* Vertical Line */}
            <div className="absolute left-[27px] md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-sand/10 via-sand/30 to-sand/10 -translate-x-1/2" data-id="element-55"></div>

            {t.about.timeline.map((event: any, index: number) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8,
            delay: index * 0.2,
            ease: [0.4, 0, 0.2, 1]
          }} className={`relative flex flex-col md:flex-row gap-8 md:gap-16 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-56">
                {/* Timeline Dot */}
                <div className="absolute left-[27px] md:left-1/2 top-2 w-3 h-3 rounded-full bg-sand shadow-[0_0_10px_rgba(212,168,83,0.5)] -translate-x-1/2 z-10" data-id="element-57"></div>

                {/* Year Marker (Mobile: Left, Desktop: Alternating) */}
                <div className={`pl-16 md:pl-0 md:w-1/2 flex ${index % 2 === 0 ? 'md:justify-start' : 'md:justify-end'}`} data-id="element-58">
                  <span className="editorial-number text-5xl md:text-6xl text-sand/20 leading-none" data-id="element-59">
                    {event.year}
                  </span>
                </div>

                {/* Content */}
                <div className={`pl-16 md:pl-0 md:w-1/2 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`} data-id="element-60">
                  <h4 className="font-serif text-2xl text-navy mb-4" data-id="element-61">
                    {event.title}
                  </h4>
                  <p className="text-dark/60 font-light leading-relaxed text-[15px]" data-id="element-62">
                    {event.description}
                  </p>

                  {/* Fire Images Strip (Only for the fire event) */}
                  {index === 1 && <div className={`mt-8 flex gap-3 ${index % 2 === 0 ? 'md:justify-end' : 'md:justify-start'}`} data-id="element-63">
                      {fireImages.map((img, i) => <div key={i} className="relative w-24 h-32 md:w-28 md:h-36 rounded-xs overflow-hidden shadow-sm group" data-id="element-64">
                          <img src={img} alt={`Incendio ${i + 1}`} className="absolute inset-0 w-full h-full object-cover grayscale-[0.5] contrast-125 group-hover:grayscale-0 transition-all duration-700" data-id="element-65" />
                          <div className="absolute inset-0 bg-navy/10 mix-blend-multiply group-hover:opacity-0 transition-opacity duration-700" data-id="element-66"></div>
                        </div>)}
                    </div>}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 section-divider z-10" data-id="element-67" />
    </section>;
}